import normalizeData from './normalizeData.js';
import stableHash from './stableHash.js';

const SUPPORTED = 'Supported';
const NOT_SUPPORTED = 'Not Supported';

/**
 *
 * @param {SpeechSynthesisVoice} voice
 * @returns {string}
 * @private
 */
function _voiceToStr(voice) {
    return `${voice.name} (${voice.lang})`;
}

/**
 * Chrome и Firefox передает список голосов только после события voiceschanged, после загрузки страницы.
 * Safari сразу отдает список голосов.
 * Возвращает объект с данными о синтезированных голосах, доступных на устройстве.
 * @returns {ISpeechData}
 */
function collectSpeechApi(window) {
    // Если недоступно, сразу отдаем результат.
    const hasSpeechSynthesis = typeof window.speechSynthesis !== 'undefined' &&
        window.speechSynthesis.onvoiceschanged !== undefined;
    if (!hasSpeechSynthesis) {
        return Promise.resolve({
            SpeechSynthesis: NOT_SUPPORTED,
            SpeechVoices: [],
            SpeechVoicesHash: 0,
        });
    }
    // Если голоса уже загрузились, сразу отдаем результат.
    const voices = window.speechSynthesis.getVoices().map(_voiceToStr);
    if (voices.length) {
        const SpeechVoices = normalizeData(voices);
        const SpeechVoicesHash = stableHash(SpeechVoices.join(','));
        return Promise.resolve({
            SpeechSynthesis: SUPPORTED,
            SpeechVoices,
            SpeechVoicesHash,
        });
    }
    // Если еще не загрузились, ждем загрузки или таймаута.
    let fulfilled = false;
    return new Promise(resolve => {
        setTimeout(() => {
            if (!fulfilled) {
                const SpeechVoices = normalizeData(window.speechSynthesis.getVoices().map(_voiceToStr));
                const SpeechVoicesHash = stableHash(SpeechVoices.join(','));
                resolve({
                    SpeechSynthesis: SUPPORTED,
                    SpeechVoices,
                    SpeechVoicesHash,
                });
            }
        }, 300);

        window.speechSynthesis.addEventListener('voiceschanged', () => {
            fulfilled = true;
            const SpeechVoices = normalizeData(window.speechSynthesis.getVoices().map(_voiceToStr));
            const SpeechVoicesHash = stableHash(SpeechVoices.join(','));
            resolve({
                SpeechSynthesis: SUPPORTED,
                SpeechVoices,
                SpeechVoicesHash,
            });
        });
    });
}

export default collectSpeechApi;